import React from "react";

import svg from "../../assets/images/icons/arrow_down.svg";

export const ArrowDownIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Arrow Down"}
    />
);
